/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, array } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import customBreakpoints from '../../../../../../helpers/customBreakpoints';

const styles = (theme) => ({
    imageContainer: {
        display: 'flex',
        '& p': {
            textTransform: 'uppercase',
            fontWeight: 600,
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: 14,
            },
        },
        [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 25,
        },
        '& img': {
            marginRight: 15,
            [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
                maxHeight: '30px !important',
                maxWidth: '30px !important',
            },
        },
    },
    iconContainer: {
        textAlign: 'center',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: 43,
        },
    },
    description: {
        margin: 0,
        marginLeft: 43,
        marginBottom: 40,
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: 14,
        },
        [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
            maxWidth: 200,
            margin: 'auto',
            textAlign: 'center',
        },
    },
    divider: {
        backgroundColor: theme.palette.black,
        width: '0.5px',
    },
});

const PlantsCare = ({ classes, careData }) => (
    <Grid container>
        {
            careData.map((item, index) => (
                <>
                    <Grid item xs={12} sm>

                        <div className={classes.imageContainer}>
                            <div className={classes.iconContainer}>
                                <img src={item.icon} alt={item.label} style={item.style} />
                            </div>
                            <p>{item.label}</p>
                        </div>
                        <p className={classes.description}>{item.description}</p>
                    </Grid>
                    {(careData.length - 1) > index && <Divider className={classes.divider} orientation="vertical" flexItem />}
                </>
            ))
        }
    </Grid>
);

PlantsCare.propTypes = {
    classes: object.isRequired,
    careData: array.isRequired,
};

export default withStyles(styles)(PlantsCare);
